import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { checkConsentStatus } from '../actions';
import { postMessageSuccess } from '../helpers/postMessage';
import ThemedSpinner from './ThemedSpinner';
//import ConsentError from './ConsentError';

const ConsentTransfer = (props) => {
  const dispatch = useDispatch();
  const [showUI, setShowUI] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [shouldPoll, setShouldPoll] = useState(false);

  // Only start polling when redirection is successful or user clicks
  useEffect(() => {
    if (!shouldPoll) return;

    let intervalId;

    const pollConsentStatus = async () => {
      try {
        await dispatch(checkConsentStatus(props.consent_guid, props.institution));
      } catch (err) {
      }
    };
    intervalId = setInterval(pollConsentStatus, 7000);
    
    return () => clearInterval(intervalId);
     
  }, [shouldPoll, dispatch, props.consent_guid, props.institution]);


  useEffect(() => {
    const redirectUrl = props.redirect_url;
    if (!redirectUrl) return;

    // Try auto-redirect after 3 seconds (like original PHP)
    const autoRedirectTimer = setTimeout(() => {
      if (!clicked) {
        const win = window.open(redirectUrl, "_blank");
        
        // If popup was successful, dispatch message and start polling
        if (win && !win.closed && typeof win.closed !== 'undefined') {
          const slug = props.institution.slug || props.institution.name || props.consent_guid;
          dispatch(postMessageSuccess("awaiting_consent", {slug: slug, type: "auto_refresh"}));
          setShouldPoll(true); // Start polling after successful redirect
        } else {
          // Popup blocked, show the manual button
          setShowUI(true);
        }
      }
    }, 3000);

    return () => {
      clearTimeout(autoRedirectTimer);
    };
  }, [props.redirect_url, dispatch, props.consent_guid, props.institution, clicked]);

  const handleClick = (e) => {
    e.preventDefault();
    
    const slug = props.institution.slug || props.institution.name || props.consent_guid;
    dispatch(postMessageSuccess("awaiting_consent", {slug: slug, type: "clicked"}));
    
    window.open(props.redirect_url, "_blank");
    setClicked(true);
    setShowUI(false);
    setShouldPoll(true); // Start polling after manual click
  };

  return (
    <div id="intro">
      <div className="consent-data-wrapper transfer-to-provider">
        <h2 className="form-group text-center">
          Transferring you to <strong>{props.institution.name}</strong>
        </h2>
        <ThemedSpinner theme={props.theme} />
        <div className="form-group text-center">We are redirecting you to the {props.institution.name} where you will login securely before viewing and authorising this request.</div>
        {showUI && !clicked && (
          <>
            <span id="redirectMsg" style={{ marginRight: 8 }}>
              If you are not redirected to the bank page, please{" "}
            </span>
            <a 
              id="openBtn" 
              href={props.redirect_url}
              target="_blank" 
              rel="noopener noreferrer" 
              onClick={handleClick}
            >
              click here
            </a>
          </>
        )}
      </div>
    </div>
  );
};

export default ConsentTransfer;